import React from "react";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";

import classNames from "classnames";

import { selectSponsors } from "../../../../features/global/globalSlice";
import { useAppSelector } from "../../../../hooks/reduxHooks";
import { SPONSOR_LOGO_URL } from "../../../../lib/globals";

const AdvertisersTable = (): React.JSX.Element => {
    const sponsors = useAppSelector(selectSponsors);

    return (
        <Table
            className={classNames(
                "w-75",
                "mx-auto",
                "advertisersTable",
                "text-center",
            )}
        >
            <thead>
                <tr>
                    <th>Logo</th>
                    <th>Name</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {sponsors.map(s => (
                    <tr key={s.id}>
                        <td>
                            {s.logo && (
                                <img
                                    src={`${SPONSOR_LOGO_URL}${s.logo}`}
                                    alt={`${s.name} logo`}
                                    className="sponsorLogo"
                                />
                            )}
                        </td>
                        <td>{s.name}</td>
                        <td>
                            <Link
                                to={`/site-management/advertisers/${s.id}`}
                                className={classNames("btn", "btn-primary")}
                            >
                                Edit
                            </Link>
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

export default AdvertisersTable;
